/**
 * Image de la page publique (Vitrine et son explorateur) : next/image sur les
 * fichiers du site et les adresses directes autorisées, servie telle quelle
 * sinon. Sans 'use client' : utilisable côté serveur comme dans
 * l'explorateur (composant client).
 */
import Image from 'next/image'

/** Hôtes autorisés à l'optimiseur (next.config.mjs, images.remotePatterns). */
const HOTES_OPTIMISES = /^https:\/\/([a-z0-9-]+\.)*(vercel-storage\.com|cdn\.bubble\.io|googleusercontent\.com)\/|^https:\/\/(images\.unsplash\.com|upload\.wikimedia\.org)\//i

/**
 * L'optimiseur ne reçoit que des fichiers statiques du site ou des adresses
 * directes autorisées. Une adresse `/api/…` (déclinaison de média sans
 * suffixe, voir src/lib/images/source-publique.ts) est servie telle quelle :
 * c'est le chemin qui cassait sur /blog le 29/09/2026.
 */
export const imageOptimisable = (src: string) => (src.startsWith('/') && !src.startsWith('/api/')) || HOTES_OPTIMISES.test(src)

/**
 * `priority` : UNE image par page (la photo de couverture de l'en-tête).
 * `eager` : chargée tout de suite sans préchargement (logo de l'en-tête).
 * Sinon `loading="lazy"` : une image d'un projet masqué ne se charge pas.
 */
export function Visuel({ src, alt, sizes, priority, eager, contain }: { src: string; alt: string; sizes: string; priority?: boolean; eager?: boolean; contain?: boolean }) {
  return (
    <Image
      src={src}
      alt={alt}
      fill
      sizes={sizes}
      priority={priority}
      loading={priority ? undefined : eager ? 'eager' : 'lazy'}
      unoptimized={!imageOptimisable(src)}
      className={contain ? 'object-contain' : 'object-cover'}
    />
  )
}
